// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-3 {
  color: #000;
  text-align: center;
  /* border-bottom: 1px solid #cacaca; */
  font-family: Titillium Web, sans-serif;
}
.section-28 {
  padding-bottom: 0;
  display: block;
}
.div-block-35 {
  background-color: #abeaed;
  padding-bottom: 50px;
}
.heading-33 {
  font-family: Titillium Web, sans-serif;
  font-size: 45px;
  font-weight: 700;
}
.section-29 {
  margin-bottom: 20px;
}
.w-layout-blockcontainer {
  max-width: 940px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.pricecontainer {
  background-color: #fff;
  border-radius: 15px;
  margin-top: -54px;
  margin-bottom: 60px;
  padding: 20px;
  box-shadow: 0 1px 18px 13px rgba(0, 123, 129, 0.04);
}
.div-block-36 {
  border-bottom: 1px solid #cacaca;
  padding: 10px;
}
.column-58 {
  text-align: left;
}
.w-button {
  display: inline-block;
  padding: 9px 15px;
  color: white;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
}
.button-14 {
  text-align: left;
  background-color: #2ecbd3;
  border: 1px solid #2ecbd3;
  border-radius: 100px;
  padding-left: 40px;
  padding-right: 40px;
}
.column-59 {
  text-align: right;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
}
.button-15 {
  color: #072125;
  background-color: #f5f5f5;
  border: 1px solid #e2e2e2;
  border-radius: 100px;
  padding-left: 40px;
  padding-right: 40px;
  font-weight: 400;
}
body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
select,
input,
textarea {
  --webkit-appearance: none;
}
ol.list.tcli > li {
  counter-increment: root;
}
ol.list.tcli > li > ol {
  counter-reset: subsection;
  list-style-type: none;
}
ol.list.tcli > li > ol > li {
  counter-increment: subsection;
}
ol.list.tcli > li > ol > li:before {
  content: counter(root) "." counter(subsection) " ";
}
.w-container .w-row {
  margin-left: -10px;
  margin-right: -10px;
}
.columns-48,
.columns-49 {
  align-items: center;
  display: flex;
}

.paragraph-86 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 15px;
}
.column-59 {
  text-align: right;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
}
.column-58 {
  text-align: left;
}
.paragraph-87 {
  width: 100%;
  object-fit: none;
  flex: 0 1 auto;
  margin-bottom: 10px;
  font-size: 18px;
  display: block;
}
.paragraph-87.pricetag {
  font-size: 25px;
  font-weight: 700;
}
.paragraph-87.semibold {
  font-weight: 600;
}
.columns-47,
.column-61 {
  align-items: center;
  display: flex;
}
.paragraph-84._15ptag {
  font-size: 15px;
}
/* ------------------------------------------ Qty styling ------------------------------------------ */
/* form {
width: 300px;
margin: 0 auto;
text-align: center;
padding-top: 50px;
} */

.value-button {
  display: inline-block;
  border: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  height: 20px;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  background: #eee;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.value-button:hover {
  cursor: pointer;
}

form #decrease {
  margin-right: -4px;
  border-radius: 8px 0 0 8px;
}

form #increase {
  margin-left: -4px;
  border-radius: 0 8px 8px 0;
}
form #decrease1 {
  margin-right: -4px;
  border-radius: 8px 0 0 8px;
}

form #increase1 {
  margin-left: -4px;
  border-radius: 0 8px 8px 0;
}

form #input-wrap {
  margin: 0px;
  padding: 0px;
}

input#number {
  text-align: center;
  border: none;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  height: 40px;
}
input#number1 {
  text-align: center;
  border: none;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  height: 40px;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ------------------------------------------ Qty styling ------------------------------------------ */
.billingforminput {
  width: 100%;
  float: left;
  margin-right: 1%;
  margin-bottom: 14px;
  padding: 10px 15px;
  border: 0;
  background-color: #f9f9f9;
  border-radius: 5px;
}
.billingCycle {
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  padding: 10px;
  border-radius: 46px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.button-141 {
  background-color: #fff !important;
  color: #000;
  font-weight: 500;
  border: 0;
  border-radius: 10px !important;
  padding-left: 40px;
  padding-right: 40px;
}
.button-141.active {
  text-align: left;
  background-color: #2ecbd3 !important;
  border: 1px solid #2ecbd3 !important;
  border-radius: 100px;
  padding-left: 40px;
  color: #fff;
  font-weight: 600;
  padding-right: 40px;
}
.billingRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  border-top: 1px solid #0000001a;
  border-bottom: 1px solid #0000001a;
  margin: 5px 0;
}
.error {
  color: red;
  font-weight: 700;
  text-align: left;
}
@media only screen and (max-width: 1000px) {
  .main-container .w-row form {
    display: block !important;
  }
  .billingCycle {
    display: block !important;
    width: 100% !important;
  }
  .ResponsiveMarginTop {
    margin-top: 20px;
  }
  .ResponsiveForm div {
    width: 100% !important;
    float: none;
  }
  .top-bar-contents {
    float: none !important;
    text-align: center !important;
    width: 100%;
    display: block !important;
  }
  div#topSection {
    align-items: center !important;
  }
  .top-bar-item {
    margin-bottom: 10px;
  }
  .widthfloat {
    width: 100% !important;
    float: left !important;
  }
}
@media only screen and (max-width: 470px) {
  section {
    padding: 0 !important;
  }
}
@media only screen and (max-width: 415px) {
  h1 span.heading-33 {
    float: none !important;
  }
}
select.billingforminput {
  max-height: 47px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mDAAmD;AACrD;AACA;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA,sGAAsG;AACtG;;;;;GAKG;;AAEH;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,sGAAsG;AACtG;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".body-3 {\n  color: #000;\n  text-align: center;\n  /* border-bottom: 1px solid #cacaca; */\n  font-family: Titillium Web, sans-serif;\n}\n.section-28 {\n  padding-bottom: 0;\n  display: block;\n}\n.div-block-35 {\n  background-color: #abeaed;\n  padding-bottom: 50px;\n}\n.heading-33 {\n  font-family: Titillium Web, sans-serif;\n  font-size: 45px;\n  font-weight: 700;\n}\n.section-29 {\n  margin-bottom: 20px;\n}\n.w-layout-blockcontainer {\n  max-width: 940px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n.pricecontainer {\n  background-color: #fff;\n  border-radius: 15px;\n  margin-top: -54px;\n  margin-bottom: 60px;\n  padding: 20px;\n  box-shadow: 0 1px 18px 13px rgba(0, 123, 129, 0.04);\n}\n.div-block-36 {\n  border-bottom: 1px solid #cacaca;\n  padding: 10px;\n}\n.column-58 {\n  text-align: left;\n}\n.w-button {\n  display: inline-block;\n  padding: 9px 15px;\n  color: white;\n  line-height: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n.button-14 {\n  text-align: left;\n  background-color: #2ecbd3;\n  border: 1px solid #2ecbd3;\n  border-radius: 100px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.column-59 {\n  text-align: right;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  display: flex;\n}\n.button-15 {\n  color: #072125;\n  background-color: #f5f5f5;\n  border: 1px solid #e2e2e2;\n  border-radius: 100px;\n  padding-left: 40px;\n  padding-right: 40px;\n  font-weight: 400;\n}\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\nselect,\ninput,\ntextarea {\n  --webkit-appearance: none;\n}\nol.list.tcli > li {\n  counter-increment: root;\n}\nol.list.tcli > li > ol {\n  counter-reset: subsection;\n  list-style-type: none;\n}\nol.list.tcli > li > ol > li {\n  counter-increment: subsection;\n}\nol.list.tcli > li > ol > li:before {\n  content: counter(root) \".\" counter(subsection) \" \";\n}\n.w-container .w-row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.columns-48,\n.columns-49 {\n  align-items: center;\n  display: flex;\n}\n\n.paragraph-86 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 15px;\n}\n.column-59 {\n  text-align: right;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  display: flex;\n}\n.column-58 {\n  text-align: left;\n}\n.paragraph-87 {\n  width: 100%;\n  object-fit: none;\n  flex: 0 auto;\n  margin-bottom: 10px;\n  font-size: 18px;\n  display: block;\n}\n.paragraph-87.pricetag {\n  font-size: 25px;\n  font-weight: 700;\n}\n.paragraph-87.semibold {\n  font-weight: 600;\n}\n.columns-47,\n.column-61 {\n  align-items: center;\n  display: flex;\n}\n.paragraph-84._15ptag {\n  font-size: 15px;\n}\n/* ------------------------------------------ Qty styling ------------------------------------------ */\n/* form {\nwidth: 300px;\nmargin: 0 auto;\ntext-align: center;\npadding-top: 50px;\n} */\n\n.value-button {\n  display: inline-block;\n  border: 1px solid #ddd;\n  margin: 0px;\n  width: 40px;\n  height: 20px;\n  text-align: center;\n  vertical-align: middle;\n  padding: 11px 0;\n  background: #eee;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.value-button:hover {\n  cursor: pointer;\n}\n\nform #decrease {\n  margin-right: -4px;\n  border-radius: 8px 0 0 8px;\n}\n\nform #increase {\n  margin-left: -4px;\n  border-radius: 0 8px 8px 0;\n}\nform #decrease1 {\n  margin-right: -4px;\n  border-radius: 8px 0 0 8px;\n}\n\nform #increase1 {\n  margin-left: -4px;\n  border-radius: 0 8px 8px 0;\n}\n\nform #input-wrap {\n  margin: 0px;\n  padding: 0px;\n}\n\ninput#number {\n  text-align: center;\n  border: none;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  margin: 0px;\n  width: 40px;\n  height: 40px;\n}\ninput#number1 {\n  text-align: center;\n  border: none;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  margin: 0px;\n  width: 40px;\n  height: 40px;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* ------------------------------------------ Qty styling ------------------------------------------ */\n.billingforminput {\n  width: 100%;\n  float: left;\n  margin-right: 1%;\n  margin-bottom: 14px;\n  padding: 10px 15px;\n  border: 0;\n  background-color: #f9f9f9;\n  border-radius: 5px;\n}\n.billingCycle {\n  width: 100%;\n  margin: 0 auto;\n  background-color: #fff;\n  padding: 10px;\n  border-radius: 46px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n.button-141 {\n  background-color: #fff !important;\n  color: #000;\n  font-weight: 500;\n  border: 0;\n  border-radius: 10px !important;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.button-141.active {\n  text-align: left;\n  background-color: #2ecbd3 !important;\n  border: 1px solid #2ecbd3 !important;\n  border-radius: 100px;\n  padding-left: 40px;\n  color: #fff;\n  font-weight: 600;\n  padding-right: 40px;\n}\n.billingRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  border-top: 1px solid #0000001a;\n  border-bottom: 1px solid #0000001a;\n  margin: 5px 0;\n}\n.error {\n  color: red;\n  font-weight: 700;\n  text-align: left;\n}\n@media only screen and (max-width: 1000px) {\n  .main-container .w-row form {\n    display: block !important;\n  }\n  .billingCycle {\n    display: block !important;\n    width: 100% !important;\n  }\n  .ResponsiveMarginTop {\n    margin-top: 20px;\n  }\n  .ResponsiveForm div {\n    width: 100% !important;\n    float: none;\n  }\n  .top-bar-contents {\n    float: none !important;\n    text-align: center !important;\n    width: 100%;\n    display: block !important;\n  }\n  div#topSection {\n    align-items: center !important;\n  }\n  .top-bar-item {\n    margin-bottom: 10px;\n  }\n  .widthfloat {\n    width: 100% !important;\n    float: left !important;\n  }\n}\n@media only screen and (max-width: 470px) {\n  section {\n    padding: 0 !important;\n  }\n}\n@media only screen and (max-width: 415px) {\n  h1 span.heading-33 {\n    float: none !important;\n  }\n}\nselect.billingforminput {\n  max-height: 47px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
